import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "flex-grow bg-background shadow-inner min-h-screen max-h-full"
}
const _hoisted_4 = { class: "p-4 lg:container lg:py-8" }
const _hoisted_5 = { class: "sm:flex flex-col lg:flex-row justify-between items-start" }
const _hoisted_6 = { class: "p-2 bg-white rounded-xl shadow justify-between items-start w-full lg:w-3/12 pb-8" }
const _hoisted_7 = { class: "flex flex-row w-full justify-end" }
const _hoisted_8 = { class: "mt-3 flex flex-col justify-between items-start px-4" }
const _hoisted_9 = { class: "border-b-2 w-full pb-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 select-none font-semibold m-2" }, "Filter by status", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down text-gray-500" }, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "space-y-3" }
const _hoisted_14 = { class: "mt-3 flex flex-col justify-between items-start px-4" }
const _hoisted_15 = { class: "border-b-2 w-full pb-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 select-none font-semibold m-2" }, "Filter by jobs", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down text-gray-500" }, null, -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "space-y-3 mt-3" }
const _hoisted_20 = { class: "mt-4 lg:mt-0 lg:space-y-4 w-full lg:w-9/12 lg:pl-8 pb-8" }
const _hoisted_21 = { class: "card-main" }
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = { class: "flex flex-col space-y-2 lg:space-y-0 lg:flex-row justify-between items-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-semibold ml-4" }, "Notifications center", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5 mr-2",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7 12l5 5l10 -10" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M2 12l5 5m5 -5l5 -5" })
], -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Mark all notifications as read ")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_31 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_34 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_37 = {
  key: 3,
  class: "flex flex-col"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_40 = {
  key: 4,
  class: "w-full flex flex-col"
}
const _hoisted_41 = {
  key: 0,
  class: "text-primary font-semibold cursor-pointer text-sm bg-primary-light rounded-lg px-5 py-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_NotificationList = _resolveComponent("NotificationList")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_SkeletonNoficatios = _resolveComponent("SkeletonNoficatios")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Loading, {
            active: _ctx.isLoading,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
            "can-cancel": false,
            loader: "spinner",
            color: "#8908F9",
            width: 128,
            height: 128,
            "is-full-page": true
          }, null, 8, ["active"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Button, {
                    variant: "",
                    label: "Clear filters",
                    class: "text-primary-dark font-semibold",
                    labelSize: "text-sm",
                    onClick: _ctx.clearFilters
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    variant: "",
                    label: "Apply",
                    labelSize: "text-sm",
                    class: "text-primary-dark font-semibold",
                    onClick: _ctx.resetSearch
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expand.status = !_ctx.expand.status)),
                      class: "flex flex-row justify-between w-full items-center"
                    }, _hoisted_12),
                    _withDirectives(_createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.status, (item, index) => {
                        return (_openBlock(), _createBlock(_component_RadioButton, {
                          key: `radio-${item.id}-${index}`,
                          label: item.name,
                          value: item.id,
                          modelValue: _ctx.radioStatus,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.radioStatus) = $event))
                        }, null, 8, ["label", "value", "modelValue"]))
                      }), 128))
                    ], 512), [
                      [_vShow, _ctx.expand.status]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expand.jobs = !_ctx.expand.jobs)),
                      class: "flex flex-row justify-between w-full items-center"
                    }, _hoisted_18),
                    _withDirectives(_createElementVNode("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (item, index) => {
                        return (_openBlock(), _createBlock(_component_RadioButton, {
                          key: `radio-${item.id}-${index}`,
                          label: item.title,
                          value: item.id,
                          modelValue: _ctx.radioJob,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.radioJob) = $event))
                        }, null, 8, ["label", "value", "modelValue"]))
                      }), 128))
                    ], 512), [
                      [_vShow, _ctx.expand.jobs]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.readAllNotifications && _ctx.readAllNotifications(...args))),
                        class: "text-sm font-medium ml-4 bg-primary-light px-3 py-2 text-purple-600 flex flex-row justify-center items-center rounded-lg shadow cursor-pointer"
                      }, _hoisted_27)
                    ]),
                    _createVNode(_component_Tabs, {
                      elements: _ctx.tabElements,
                      modelValue: _ctx.tab,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tab) = $event))
                    }, null, 8, ["elements", "modelValue"]),
                    (_ctx.tab === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          (!_ctx.loadingNotif)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                (!_ctx.isLoading && _ctx.notifications.length > 0)
                                  ? (_openBlock(), _createBlock(_component_NotificationList, {
                                      key: 0,
                                      notifications: _ctx.notifications
                                    }, null, 8, ["notifications"]))
                                  : (_openBlock(), _createBlock(_component_EmptyState, {
                                      key: 1,
                                      message: "No notifications",
                                      class: "mt-4"
                                    }))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 4, 5, 6, 7, 8, 9, 10], (item, index) => {
                                  return _createElementVNode("div", { key: index }, [
                                    _createVNode(_component_SkeletonNoficatios)
                                  ])
                                }), 64))
                              ]))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tab === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          (!_ctx.loadingNotif)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                (!_ctx.isLoading && _ctx.notifications.length > 0)
                                  ? (_openBlock(), _createBlock(_component_NotificationList, {
                                      key: 0,
                                      notifications: _ctx.notifications
                                    }, null, 8, ["notifications"]))
                                  : (_openBlock(), _createBlock(_component_EmptyState, {
                                      key: 1,
                                      message: "No notifications",
                                      class: "mt-4"
                                    }))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 4, 5, 6, 7, 8, 9, 10], (item, index) => {
                                  return _createElementVNode("div", { key: index }, [
                                    _createVNode(_component_SkeletonNoficatios)
                                  ])
                                }), 64))
                              ]))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tab === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          (!_ctx.loadingNotif)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                (!_ctx.isLoading && _ctx.notifications.length > 0)
                                  ? (_openBlock(), _createBlock(_component_NotificationList, {
                                      key: 0,
                                      notifications: _ctx.notifications
                                    }, null, 8, ["notifications"]))
                                  : (_openBlock(), _createBlock(_component_EmptyState, {
                                      key: 1,
                                      message: "No notifications",
                                      class: "mt-4"
                                    }))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 4, 5, 6, 7, 8, 9, 10], (item, index) => {
                                  return _createElementVNode("div", { key: index }, [
                                    _createVNode(_component_SkeletonNoficatios)
                                  ])
                                }), 64))
                              ]))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tab === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          (!_ctx.loadingNotif)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                (!_ctx.isLoading && _ctx.notifications.length > 0)
                                  ? (_openBlock(), _createBlock(_component_NotificationList, {
                                      key: 0,
                                      notifications: _ctx.notifications
                                    }, null, 8, ["notifications"]))
                                  : (_openBlock(), _createBlock(_component_EmptyState, {
                                      key: 1,
                                      message: "No notifications",
                                      class: "mt-4"
                                    }))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 4, 5, 6, 7, 8, 9, 10], (item, index) => {
                                  return _createElementVNode("div", { key: index }, [
                                    _createVNode(_component_SkeletonNoficatios)
                                  ])
                                }), 64))
                              ]))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.loadingMoreNotifications)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2], (item, index) => {
                            return _createElementVNode("div", { key: index }, [
                              _createVNode(_component_SkeletonNoficatios)
                            ])
                          }), 64))
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.loadingMoreNotifications && _ctx.page)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 5,
                          class: "w-full flex flex-col justify-center items-center mt-6",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
                        }, [
                          (!_ctx.loadingNotif && _ctx.notifications.length > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Load more notifications"))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ]))
  ]))
}